var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorRegistryDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2188 17.9514C35.2188 16.1754 35.2188 15.2874 35.0255 14.5588C34.501 12.5818 32.9722 11.0375 31.0149 10.5077C30.2936 10.3125 29.4145 10.3125 27.6562 10.3125C25.898 10.3125 25.0189 10.3125 24.2976 10.5077C22.3403 11.0375 20.8115 12.5818 20.287 14.5588C20.0937 15.2874 20.0938 16.1754 20.0938 17.9514M14.8 44.6875H40.5125C42.6302 44.6875 43.689 44.6875 44.4979 44.2712C45.2094 43.905 45.7878 43.3207 46.1504 42.602C46.5625 41.785 46.5625 40.7155 46.5625 38.5764V24.0625C46.5625 21.9234 46.5625 20.8539 46.1504 20.0368C45.7878 19.3182 45.2094 18.7339 44.4979 18.3677C43.689 17.9514 42.6302 17.9514 40.5125 17.9514H14.8C12.6823 17.9514 11.6235 17.9514 10.8146 18.3677C10.1031 18.7339 9.52465 19.3182 9.16213 20.0368C8.75 20.8539 8.75 21.9234 8.75 24.0625V38.5764C8.75 40.7155 8.75 41.785 9.16213 42.602C9.52465 43.3207 10.1031 43.905 10.8146 44.2712C11.6235 44.6875 12.6823 44.6875 14.8 44.6875Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorRegistryDark);
export default __webpack_public_path__ + "static/media/vendor-registry-dark.ac1eaff54519240efb046a149b9718e8.svg";
export { ForwardRef as ReactComponent };